module.exports = __webpack_public_path__ + "img/new-media-research.03d561d0.jpg";